import { ReactNode } from 'react';

import { DropdownMenuHolder } from './DropdownMenu.styled';

type Props = {
  width: number;
  children: ReactNode;
};

export function DropdownMenu({ width, children }: Props) {
  return <DropdownMenuHolder style={{ width }}>{children}</DropdownMenuHolder>;
}
